import React, { createContext, useContext } from "react";
import { JobPost } from "@/types/jobPost";
import { FilterJobsAction } from "../FilterJobsProvider";
import { JobPostFilterOptions } from "@/hooks";
import {
  JobPostFilterResponse,
  PaginationState,
} from "@/hooks/jobPosts/useJobPosts";
import { DateOption } from "@/hooks/jobPosts/useJobPostFilterOptions";

export const MIN_SALARY = 0;
export const MAX_SALARY = 300000;

export const YEAR_MIN = 1975;
export const YEAR_MAX = new Date().getFullYear();

export interface JobPostFiltersState {
  selectedCompanies: JobPostFilterOptions["companies"];
  selectedHealthcareDomains: JobPostFilterOptions["healthcareDomains"];
  selectedLocations: JobPostFilterOptions["locations"];
  selectedCompanySizes: JobPostFilterOptions["companySizes"];
  selectedDepartments: JobPostFilterOptions["departments"];
  selectedJobRoles: JobPostFilterOptions["jobRoles"];
  selectedJobSettings: JobPostFilterOptions["jobSettings"];
  selectedJobSalaryCurrencies: JobPostFilterOptions["jobSalaryCurrencies"];
  selectedSalaryRangeMin: JobPost["job_salary_min"];
  selectedSalaryRangeMax: JobPost["job_salary_max"];
  selectedDatePostedOption: DateOption | null;
  selectedDateUpdatedOption: DateOption | null;
  search?: string;
}
export interface FilterJobsContextProps {
  jobPosts: JobPostFilterResponse["jobPostValues"];
  filters: JobPostFilterResponse["filterValues"];

  loading: boolean;
  error: string | null;
  dispatch: React.Dispatch<FilterJobsAction>;

  resetFilters: () => void;
  noMatchingResults: boolean;
  getNoResultsMessage: () => string;

  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  pagination: PaginationState;
}

export const FilterJobsContext = createContext<FilterJobsContextProps | null>(
  null,
);

export function useFilterJobs() {
  const context = useContext(FilterJobsContext);
  if (!context) {
    throw new Error(
      "useFilterJobsState must be used within a FilterJobsStateProvider",
    );
  }
  return context;
}
